import React, { useState } from 'react';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router';

const Footer = ({}) => {
  const navigate = useNavigate();
  return (
    <footer
      style={{
        backgroundColor: '#2f5c65',
        color: 'white',
        padding: '1rem',
        textAlign: 'center',
        position: 'relative',
        bottom: '0',
        width: '100%',
      }}
    >
      <Typography
        variant="body2"
        sx={{ cursor: 'pointer' }}
        onClick={() => navigate('/terms-conditions')}
      >
        Terms & Conditions
      </Typography>
      <Typography
        variant="body2"
        sx={{ cursor: 'pointer' }}
        onClick={() => navigate('/privacy-policy')}
      >
        Privacy Policy
      </Typography>
    </footer>
  );
};

export default Footer;
